<template>
  <div class="nx-test-page-wrapper white" style="height: 100vh;">

    <v-container fluid style="background: white">
      <v-layout class="row wrap">
        <v-flex class="xs6 offset-xs3 sm8 offset-sm2">
          <nx-form :value="value"
                   validation-mode="eager"
                   v-on="$listeners"
                   v-slot="{ draft, form }"
                   ref="form">
            <nx-string-array-list
              :name="name"
              :value="currentValue"
              label="prueba"
              @input="onInput"
              sortable
              :disableDelete="true"
              :disableAdd="true"
            ></nx-string-array-list>
            <nx-string-array-selector
              :name="name"
              :value="currentValue"
              label="prueba"
              @input="onInput"
              sortable
              :disableDelete="true"
              :disableAdd="true"
            ></nx-string-array-selector>
          </nx-form>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import BasePage from '@/pages/BasePage';
import FormChips from '../modules/form/components/FormChips';

export default {
  name: 'nx-test-page',
  extends: BasePage,

  provide() {
    return {
      $entityId: 1001113,
    };
  },
  components: {
    [FormChips.name]: FormChips,
  },
  props: {},
  data() {
    return {
      dialog: false,
      dialog2: false,
      scope: 'scope',
      value: {},
      value2: [],
      name: 'name',
      currentValue: [
        '2 cuartos traseros de pollo',
        '100 g castañas peladas',
        '1 vaso vino dulce',
        '1 batata',
        'Aceite, tomillo, sal, pimienta y pimentón dulce',
      ],
      limit: 1,
      canSelectAll: false,
      placeholder: 'placeholder',
    };
  },
  watch: {},
  methods: {
    onBlur() {
      this.$emit('blur', this.currentValue);
    },
    onInput($event) {
      this.currentValue = $event;
      this.$emit('input', this.currentValue);
    },
    selectAllItems() {
      this.currentValue = this.currentValue.length > 0 ? [] : this.items.map(item => item.value);
      this.$emit('input', this.currentValue);
    },
    /**
     * Default value handler.
     * Implemented as a method so it can be overrided.
     */
    onDefault(defaultValue) {
      this.$emit('input', defaultValue);
      this.$emit('blur', defaultValue);
      this.$nextTick(this.validate);
    },
  },
  computed: {

  },
  beforeCreate() {
  },
  mounted() {
    this.finishLoading();
  },
};
</script>
<style>
.v-list__tile--avatar {
  height: auto;
  margin: 10px 0;
}
.v-list__tile--avatar .v-image {
  margin: 0 20px 0 0;
}
</style>
